var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanned(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.915,
    height: 32,
    viewBox: "0 0 25.915 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Planned_Enable",
    "data-name": "Planned Enable",
    transform: "translate(17.547 -171.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2750",
    "data-name": "Path 2750",
    d: "M8.368,171.688c0-.077-.007-.155-.01-.232q-12.87,0-25.74,0c-.134,0-.165.03-.165.165q.005,15.913,0,31.826c.06,0,.119.009.179.009H8.368S8.368,174.768,8.368,171.688ZM-14.593,201c-.266,0-.267,0-.267-.267q0-13.278,0-26.557c0-.274,0-.275.277-.275H5.475c.263,0,.264,0,.264.267,0,1.785,0,20.1,0,26.827Z",
    transform: "translate(0 0)",
    fill: "#4672ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2751",
    "data-name": "Path 2751",
    d: "M67.87,279.623c0-.306,0-.307-.3-.307H52.17c-.24,0-.253.013-.253.253q0,1.316,0,2.632c0,.218.016.235.235.235q7.744,0,15.488,0c.181,0,.234-.059.233-.238C67.865,281.342,67.87,280.483,67.87,279.623Z",
    transform: "translate(-64.481 -100.127)",
    fill: "#4672ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2752",
    "data-name": "Path 2752",
    d: "M60.594,360.106q-4.243.007-8.486,0c-.175,0-.226.061-.225.228.006.877,0,1.754,0,2.632,0,.243,0,.244.255.244h8.432c.235,0,.239,0,.239-.241,0-.877,0-1.754,0-2.632C60.817,360.171,60.771,360.106,60.594,360.106Z",
    transform: "translate(-64.451 -175.121)",
    fill: "#4672ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2753",
    "data-name": "Path 2753",
    d: "M56.812,440.968c-.782.006-1.564,0-2.346,0s-1.576,0-2.364,0c-.157,0-.209.053-.208.207q.006,1.343,0,2.686c0,.148.04.214.2.213q2.364-.007,4.728,0c.157,0,.207-.053.206-.208q-.008-1.343,0-2.686C57.033,441.011,56.971,440.967,56.812,440.968Z",
    transform: "translate(-64.46 -250.183)",
    fill: "#4672ba"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanned);
export default __webpack_public_path__ + "static/media/Planned.905164c9.svg";
export { ForwardRef as ReactComponent };